function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useScreenSize } from '../../../hooks';
import { buildClassNames } from '../../../modules/css-helpers';
import { hasVariant } from '../../../modules/variant-helpers';
import { colors, ScreenSize } from '../../../theme';
import { createOwnUpComponent } from '../../components';
import { OwnUpIcon } from '../../images/icons';
import { OwnUpAppBarStyle } from './style';
/**
 * App Bar component properties.
 */

var StyledComponent = createOwnUpComponent('div', OwnUpAppBarStyle);
/**
 * An Own Up branded app bar. Changes background color depending on the
 *   variant type.
 *
 * @param props see {@link OwnUpHeaderProps}
 */

export var OwnUpAppBar = function OwnUpAppBar(_ref) {
  var className = _ref.className,
      home = _ref.home,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "home", "children"]);

  var classes = buildClassNames('ou-app-bar', className);
  var screenSize = useScreenSize();
  var hasMinimalVariant = hasVariant(props.variant, 'minimal');
  var icon = hasMinimalVariant ? screenSize < ScreenSize.medium ? 'OwnUpLogoNoBackdrop' : 'OwnUpLogoNoBackdropWithText' : 'OwnUpLogoWithText';
  var color = hasMinimalVariant ? colors.LOGO_SHADOW : colors.WHITE;
  var logoIcon = /*#__PURE__*/React.createElement(OwnUpIcon, {
    icon: icon,
    color: color,
    height: "24px"
  });
  var logo = /*#__PURE__*/React.createElement("div", {
    className: "ou-app-bar__logo"
  }, logoIcon);
  return /*#__PURE__*/React.createElement(StyledComponent, _extends({
    className: classes
  }, props), /*#__PURE__*/React.createElement("a", {
    href: home || 'https://www.ownup.com/'
  }, logo), children);
};